import { fg } from '@confluence/feature-gating';
import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';

/**
 * Handler for recording SSR measurements in confluence.
 * This is the SSR implementation that writes to SSRMeasures.
 */
function recordSSRMeasureImpl(measure: {
	segmentName: string;
	startTimestamp: number;
	endTimestamp: number;
}) {
	if (!fg('platform_editor_better_editor_ssr_spans')) {
		return;
	}

	// Only record on server-side and during SSR
	SSRMeasures.addMeasureWithData(measure.segmentName, {
		startTime: measure.startTimestamp,
		duration: measure.endTimestamp - measure.startTimestamp,
	});
}

/**
 * No-op handler for client builds.
 * This version does nothing and is tree-shakeable.
 */
function recordSSRMeasureNoOp() {
	// No-op on client
}

/**
 * The SSRMeasuresHandler singleton.
 * On SSR builds, uses the implementation that records to SSRMeasures.
 * On client builds, uses the no-op implementation.
 */
export const recordSSRMeasure = process.env.REACT_SSR // eslint-disable-line check-react-ssr-usage/no-react-ssr
	? recordSSRMeasureImpl
	: recordSSRMeasureNoOp;
